import { render } from "./AppTab.vue?vue&type=template&id=d546ef96&scoped=true&ts=true"
import script from "./AppTab.vue?vue&type=script&lang=ts"
export * from "./AppTab.vue?vue&type=script&lang=ts"

import "./AppTab.vue?vue&type=style&index=0&id=d546ef96&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d546ef96"]])

export default __exports__